export default __webpack_public_path__ + "static/media/65f3a9cec473401d13499a808ef338841576523917274.7e4a8714.webp";